import React, { useEffect, useState } from 'react'
import Card from '../../../Base/Components/Card/Card'
import { dyeingConsumosPorPartida } from '../../../API/Produccion/Dyeing/DyeingRequests';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';

const PartidasAdicionesScreen = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);


    const getInfo = async () => {
        setLoading(true);
        // try {
            const response = await dyeingConsumosPorPartida();
            console.log(response);
            setData(response);
        //     setLoading(false);
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        //     setLoading(false);
        // } finally {
            setLoading(false);
        // }
    }


    const columns = [
        {
            field: 'IdDyeGroup',
            header: 'Partida',
            headerEn: '',
            className: '',
        },
        {
            field: 'LabDip',
            header: 'LabDip',
            headerEn: '',
            className: '',
        },
        {
            field: 'ColorName',
            header: 'Color',
            headerEn: '',
            className: '',
            Sumary: 'count'
        },
        {
            field: 'NoLotes',
            header: 'NoLotes',
            headerEn: '',
            className: 'XXsmall',
            Sumary: 'sum'
        },
        {
           headerName: 'Producción Kgs',
           children: [
               {
                   field: 'Kgs_Normal',
                   header: 'Normal',
                   headerEn: '',
                   className: 'small',
                   Format: 'Currency',
                   Sumary: 'sum',
               },
               {
                   field: 'Kgs_Reproceso',
                   header: 'Reproceso',
                   headerEn: '',
                   className: 'small',
                   Format: 'Currency',
                   Sumary: 'sum',
               },
               {
                   field: 'Kgs_Lavado',
                   header: 'Lavado',
                   headerEn: '',
                   className: 'small',
                   Format: 'Currency',
                   Sumary: 'sum',
               },
            
            ]
        },
        {
           headerName: 'Quimicos y Colorantes Kgs',
           children: [
               {
                   field: 'Original',
                   header: 'Original',
                   headerEn: '',
                   className: 'small',
                   Format: 'Currency',
                   Sumary: 'sum',
               },
               {
                   field: 'Adicion',
                   header: 'Adicion',
                   headerEn: '',
                   className: 'small',
                   Format: 'Currency',
                   Sumary: 'sum',
               },
            ]
        },
    ]

    const table = {
        Columns: columns,
        Data: data,
        loading: loading
    }

    useEffect(() => {
        getInfo();
    }, [])




  return (
    <div>
        <Card
        titulo={<div><h4>Partidas y Adiciones</h4></div>}
        contenido={<div className='pt-1' style={{ height: '90vh' }}>
            <AgGrid table={table} />
        </div>}
        />
    </div>
  )
}

export default PartidasAdicionesScreen